import * as types from "./types.js"
import * as api from "./api.js"


function getJobsRequest() {
    return {
        type: types.GET_JOBS_REQUEST
    }
}

function getJobsReceived(jobs) {
    return {
        type: types.GET_JOBS_RECEIVED,
        payload: jobs
    }
}

function getJobsError(e) {
    return {
        type: types.GET_JOBS_ERROR,
        payload: e,
        error: true
    }
}

export function getJobs(personid) {
    return dispatch => {
        dispatch(getJobsRequest())
        return api.getJobs(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getJobsError(res.statusText))
            } else {
                return res.json()
                .then(jobs => {
                    dispatch(getJobsReceived(jobs))
                })
            }
        })
    }
}


function postJobRequest() {
    return {
        type: types.POST_JOB_REQUEST
    }
}

function postJobReceived(job) {
    return {
        type: types.POST_JOB_RECEIVED,
        payload: job
    }
}

function postJobError(e) {
    return {
        type: types.POST_JOB_ERROR,
        payload: e,
        error: true
    }
}

export function postJob(job) {
    return dispatch => {
        dispatch(postJobRequest())
        return api.postJob(job)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postJobError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(postJobReceived({
                        id: stats.id,
                        employer: job.employer,
                        position: job.position,
                        fromdate: job.fromdate,
                        todate: job.todate
                    }))
                })
            }
        })
    }
}

function putJobRequest() {
    return {
        type: types.PUT_JOB_REQUEST
    }
}

function putJobReceived(stats) {
    return {
        type: types.PUT_JOB_RECEIVED,
        payload: stats
    }
}

function putJobError(e) {
    return {
        type: types.PUT_JOB_ERROR,
        payload: e,
        error: true
    }
}

export function putJob(job) {
    return (dispatch) => {
        dispatch(putJobRequest())
        return api.putJob(job)
        .then(res => {
            if (res.status !== 200) {
                dispatch(putJobError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(putJobReceived({
                        id: job.id,
                        employer: job.employer,
                        position: job.position,
                        fromdate: job.fromdate,
                        todate: job.todate === null ? "until today" : job.todate
                    }))
                })
            }
        })
    }
}

function deleteJobRequest() {
    return {
        type: types.DELETE_JOB_REQUEST
    }
}

function deleteJobReceived(job) {
    return {
        type: types.DELETE_JOB_RECEIVED,
        payload: job
    }
}

function deleteJobError(e) {
    return {
        type: types.DELETE_JOB_ERROR,
        payload: e,
        error: true
    }
}

export function deleteJob(id) {
    return dispatch => {
        dispatch(deleteJobRequest())
        return api.deleteJob(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteJobError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteJobReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/jobs/actions.js
 **/